import { SectionCarousel } from '@sbercloud/uikit-product-site-section';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { BlogsProps } from 'src/types/backendContent';

import { CarouselBase } from '../CarouselBase';

export type NewsProps = {
  id?: string;
  blogs: BlogsProps[];
  title?: string;
  className?: string;
};

export function NewsCarousel({ blogs, id, title, className }: NewsProps) {
  const layoutType = useLayoutType();

  return (
    <SectionCarousel
      id={id}
      layoutType={layoutType}
      title={title}
      itemMinWidth={200}
      maxItemsPerPage={4}
      infiniteScroll
      className={className}
    >
      {blogs.map((blog) => (
        <CarouselBase.News key={id} {...blog} />
      ))}
    </SectionCarousel>
  );
}
